import { t } from "@/i18n-js/instance";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { Modal } from "@circle-react-uikit/ModalV2";

const WorkflowUsageModalComponent = () => {
  const modal = useModal();

  const handleClose = () => {
    void modal.hide();
    modal.remove();
  };

  return (
    <Modal isOpen={modal.visible} onClose={handleClose}>
      <Modal.Overlay />
      <Modal.Content size="full" className="max-w-screen-xl">
        <Modal.Header>
          <Modal.Title>
            {t("settings.billing.ai_actions.modal_title")}
          </Modal.Title>
          <Modal.HeaderActions>
            <Modal.CloseButton onClick={handleClose} />
          </Modal.HeaderActions>
        </Modal.Header>
        <Modal.Body className="flex h-full flex-col p-8">
          {/* Empty body */}
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

const WorkflowUsageModalDrawer = ModalManager.create(() => (
  <WorkflowUsageModalComponent />
));

export const useWorkflowUsageModal = () => useModal(WorkflowUsageModalDrawer);
